import {SvgIcon} from "@mui/material";
import * as React from "react";

const ChangePersonGroupIcon = ({text, person}) => {
    const maskId = `mask-${text.replace(/\s+/g, '-')}-${Date.now()}`;
    return (
        <>
            {
                person ?
                    (((text === "MCG" && person.hasOwnProperty("change_person_group_pending") && person.change_person_group_pending)
                        || (text === "TM" && person.hasOwnProperty("change_person_job_pending") && person.change_person_job_pending)) &&
                    <SvgIcon sx={{marginTop: '-1px'}}>
                        <svg width="23" height="22" viewBox="0 0 24 24" fill="black">
                            <defs>
                                <mask  id={maskId}>
                                    <rect width="23" height="22" fill="white"/>
                                    <text
                                        x="12"
                                        y="14"
                                        textAnchor="middle"
                                        fontFamily="Arial, sans-serif"
                                        fontSize="8"
                                        fontWeight="bold"
                                        fill="black"
                                    >
                                        {text}
                                    </text>
                                </mask>
                            </defs>

                            <path
                                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-9 6H8v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h3v-1h-2v-2h2c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm9 0h-3v4h1v-2h2v-1h-2V9h2V8h-3v6h5v-2h-2v-2z"
                                mask={`url(#${maskId})`}
                            />
                        </svg>
                    </SvgIcon>
                    )
                    :
                    <SvgIcon sx={{marginTop: '-1px'}}>
                        <svg width="23" height="22" viewBox="0 0 24 24" fill="black">
                            <defs>
                                <mask  id={maskId}>
                                    <rect width="23" height="22" fill="white"/>
                                    <text
                                        x="12"
                                        y="14"
                                        textAnchor="middle"
                                        fontFamily="Arial, sans-serif"
                                        fontSize="8"
                                        fontWeight="bold"
                                        fill="black"
                                    >
                                        {text}
                                    </text>
                                </mask>
                            </defs>

                            <path
                                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-9 6H8v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h3v-1h-2v-2h2c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm9 0h-3v4h1v-2h2v-1h-2V9h2V8h-3v6h5v-2h-2v-2z"
                                mask={`url(#${maskId})`}
                            />
                        </svg>
                    </SvgIcon>
            }
        </>
    )
}

export default ChangePersonGroupIcon;